export default {
  title: 'app-info',
  get api() {
    return {
      auth: {
        requestToken: '​_Auth​/RequestToken',
        request2Authentication: '​_Auth​/Request2Authentication',
        getAuthUser: '​_Auth​/GetAuthUser'
      },
      location: {
        getListReportTree: 'Location​/GetListReportTree',
        getAll: 'Location/GetAll',
        getById: 'Location​/GetById',
        post: 'Location​/Post',
        put: 'Location​/Put',
        delete: 'Location​/Delete'
      },
      report: {
        createAverageReport: 'Report/CreateAverageReport',
        createAverageReportByDCEID: 'Report/CreateAverageReportByDCEID',
        createAverageReportBySubDeviceName:
          'Report/CreateAverageReportBySubDeviceName',
        postCreateAverageReportBySubDeviceName:
          'Report/PostCreateAverageReportBySubDeviceName',
        thisMonthConsumptionAndBill: 'Report/ThisMonthConsumptionAndBill',
        getReportDevicedifference: 'Report/GetReportDevicedifference'
      },
      reportTree: {
        getCustTreeSensorFiltered: 'ReportTree/GetCustTreeSensorFiltered',
        getCustTreeSensorLevel: 'ReportTree/GetCustTreeSensorLevel'
      },
      formula: {
        getAll: 'Formula/GetAll',
        getById: 'Formula/GetById',
        getAllComponent: 'Formula/GetAllComponent',
        getAllCustomerFormula: 'Formula/GetAllCustomerFormula',
        getAllConstantMaster: 'Formula/GetAllConstantMaster',
        getAllListTags: 'Formula/GetAllListTags',
        insertNewFormula: 'Formula/InsertNewFormula',
        insertBulkNewFormula: 'Formula/InsertBulkNewFormula',
        isAvailableVarNameFormula: 'Formula/IsAvailableVarNameFormula',
        createMultipleReportFormula: 'Formula/CreateMultipleReportFormula',
        post: 'Formula/Post',
        put: 'Formula/Put',
        delete: 'Formula/Delete'
      },
      manualConfig: {
        getListServerLocation: 'ManualConfig/GetListServerLocation',
        optionsEnumDataFormDashboard:
          'ManualConfig/OptionsEnumDataFormDashboard'
      },
      customer: {
        getAll: 'Customer/GetAll',
        getListCustomerByServerCode: 'Customer/GetListCustomerByServerCode',
        getListCustomerByMultipleServerCode:
          'Customer/GetListCustomerByMultipleServerCode'
      },
      treeGroupDevice: {
        getCustTreeSensorLevel: 'TreeGroupDevice/GetCustTreeSensorLevel',
        getListSensorByDevice: 'TreeGroupDevice/GetListSensorByDevice',
        getCustTreeDeviceLevel: 'TreeGroupDevice/GetCustTreeDeviceLevel',
        getCustTreeGroupDeviceLevel:
          'TreeGroupDevice/GetCustTreeGroupDeviceLevel',
        getCustTreeGroupDeviceLevelWithFormula:
          'TreeGroupDevice/GetCustTreeGroupDeviceLevelWithFormula'
      },
      dashboard: {
        getWidgetSetting: 'Dashboard/GetWidgetSetting',
        getDashboardWidgetData: 'Dashboard/GetDashboardWidgetData',
        getListAvailableWidget: 'Dashboard/GetListAvailableWidget',
        changeWidgetSetting: 'Dashboard/ChangeWidgetSetting'
      },
      user: {
        getAllUserRp: 'User/GetAllUserRp',
        createUserRoles: 'User/CreateUserRoles',
        getAllUserRpByUsername: 'User/GetAllUserRpByUsername',
        isAvailableUsername: 'User/IsAvailableUsername',
        getAll: 'User/GetAll',
        getById: 'User/GetById',
        post: 'User/Post',
        put: 'User/Put',
        delete: 'User/Delete'
      },
      role: {
        getById: 'Roles/GetById',
        getAll: 'Roles/GetAll',
        post: 'Roles/Post',
        put: 'Roles/Put',
        delete: 'Roles/Delete'
      },
      permission: {
        getAll: 'Permission/GetAll',
        getById: 'Permission/GetById',
        post: 'Permission/Post',
        put: 'Permission/Put',
        delete: 'Permission/Delete'
      }
    }
  }
}
